import classNames from "classnames";
import { get } from "lodash";
import { MdCheck, MdInfoOutline } from "react-icons/md";

const ProductCard = ({
  name,
  alias,
  info,
  link,
  showGuarantee,
  isSelected,
  selectProduct,
  costDetails,
  currency = "EUR",
}) => {
  const formatCost = (cost) => {
    if (!cost) return null;
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cost);
  };

  // Check if costDetails is for a specific beneficiary
  const beneficiaryCost = get(costDetails, "beneficiaryCost");
  const isSpecificBeneficiary = beneficiaryCost !== undefined;

  let displayCost = null;
  if (costDetails) {
    if (isSpecificBeneficiary) {
      // For specific beneficiary, show the cost for that person
      displayCost = formatCost(beneficiaryCost);
    } else {
      // For main product (adherent), show only adherent cost
      const adherentCost = get(costDetails, "adherentCost");
      displayCost = adherentCost ? formatCost(adherentCost) : null;
    }
  }

  return (
    <div className="product--item" onClick={selectProduct}>
      <div
        className={classNames({
          "recommended--product": isSelected,
        })}
      >
        <div className="product--item--wrapper">
          <div className="product--item--header">
            <div className="product--item--header--top">
              <span className="--name">{name}</span>
            </div>
            {displayCost && (
              <div className="product--item--header--top">
                <span className="--name">{displayCost}</span>
              </div>
            )}
            <p className="product--item--description">{alias}</p>
          </div>
          <div className="product--item--info">
            <span className="product--item--info--title">{info?.title}</span>
            <div className="product--item--info--list">
              {get(info, "items", []).map((item, i) => (
                <div key={`info.item.${i}`} className="item">
                  <MdCheck size={20} />
                  <div className="content">{item.mainInfo}</div>
                  <MdInfoOutline
                    onClick={() => showGuarantee(item)}
                    size={20}
                    color="#808080"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="product--item--link" onClick={link?.onClick}>
            {link?.label}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
